'use strict';

var React = require('react');
var moment = require('moment');
var Day = require('./Day');
var CalendarControls = require('./CalendarControls');


class Calendar extends React.Component {
    state = {
        date: moment()
    };

    next = () => {
        this.setState({date: this.state.date.add(1, 'months')});
    }

    prev = () => {
        this.setState({date: this.state.date.subtract(1, 'months')});
    }

    createDay = (day) => {
        return {
            day: day.date(),
            date: day
        };
    }

    /**
     * Return an array of days for the current month
     */

    days = () => {
        var days = [];
        var date = this.state.date.startOf('month');
        var diff = date.weekday() - this.props.weekOffset;
        if (diff < 0) diff += 7;

        var i;
        for (var i = 0; i < diff; i++) {
            var day = moment({y: this.state.date.year(), M: this.state.date.month()}).add(i - diff, 'days'),
                isBooked = this.props.bookedOn.indexOf(day.format('YYYY-MM-DD')) > -1;

            days.push({day: day, classes: 'prev-month', isBooked: isBooked});
        }

        var numberOfDays = date.daysInMonth();
        for (i = 1; i <= numberOfDays; i++) {
            var day = moment({y: this.state.date.year(), M: this.state.date.month(), d: i}),
                isBooked = this.props.bookedOn.indexOf(day.format('YYYY-MM-DD')) > -1,
                isSwitchDay = this.props.bookedOn[this.props.bookedOn.indexOf(day.format('YYYY-MM-DD')) + 1] === '|';

            days.push({day: day, isBooked: isBooked, isSwitchDay: isSwitchDay});
        }

        i = 1;
        while (days.length % 7 !== 0) {
            var day = moment({y: this.state.date.year(), M: this.state.date.month()}).add(numberOfDays - 1 + i, 'days'),
                isBooked = this.props.bookedOn.indexOf(day.format('YYYY-MM-DD')) > -1;

            days.push({day: day, classes: 'next-month', isBooked: isBooked});
            i++;
        }

        return days;
    }

    render() {
        var renderDay = function (day, i) {
            return <Day key={'day-' + i} day={day} />;
        };

        return (
            <div className='clndr'>
                <CalendarControls date={this.state.date} onNext={this.next} onPrev={this.prev} />
                <div className='clndr-grid'>
                    <div className='days'>
                        <div>
                            <span className="day-number dow">Mo</span>
                        </div>
                    </div>
                    <div className='days'>
                        <div>
                            <span className="day-number dow">Di</span>
                        </div>
                    </div>
                    <div className='days'>
                        <div>
                            <span className="day-number dow">Mi</span>
                        </div>
                    </div>
                    <div className='days'>
                        <div>
                            <span className="day-number dow">Do</span>
                        </div>
                    </div>
                    <div className='days'>
                        <div>
                            <span className="day-number dow">Fr</span>
                        </div>
                    </div>
                    <div className='days'>
                        <div>
                            <span className="day-number dow">Sa</span>
                        </div>
                    </div>
                    <div className='days'>
                        <div>
                            <span className="day-number dow">So</span>
                        </div>
                    </div>
                </div>
                <div className='clndr-grid'>
                    <div className='days'>
            {this.days().map(renderDay)}
                    </div>
                    <div className='clearfix'></div>
                </div>
            </div>
        );
    }
}

Calendar.defaultProps = {
    weekOffset: 0,
    lang: 'de',
    forceSixRows: true
};

module.exports = Calendar;



// WEBPACK FOOTER //
// ./src/components/Calendar.js